/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.A4uFast = A4uFast;

var _react = _interopRequireDefault(require("react"));

var _util = require("./util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function A4uFast(_ref) {
  var _ref$scale = _ref.scale,
      scale = _ref$scale === void 0 ? 'M' : _ref$scale,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'LIGHT' : _ref$color,
      props = _objectWithoutProperties(_ref, ["scale", "color"]);

  return _react["default"].createElement("svg", _extends({
    viewBox: _util.viewBoxes[scale]
  }, props, props), _react["default"].createElement("path", {
    d: "M27.909 13.432a4.729 4.729 0 0 0-1.052-.043L18.516 5.9a6.888 6.888 0 0 0 .964 4.637c.808 1.262 3.14 2.7 5.028 3.71a3.178 3.178 0 0 0-1.227 1.982 3.069 3.069 0 0 0 .1 1.4 13.207 13.207 0 0 0-5.918-4.129c-5.437-1.488-7.476-.661-8.927-.5a2.748 2.748 0 0 0 .331-1 2.784 2.784 0 1 0-2.515 2.417l-.283.691C3.225 20.983 7.141 24.1 9.513 25.435c.838.473 3.529 1.535 3.529 1.535l-3.605 2.611A1.849 1.849 0 0 0 8.868 32s3.214-1.934 6.579-3.984L20 30a2.141 2.141 0 0 0 2.645-.832l-4.766-2.638a249.35 249.35 0 0 0 4.4-2.744 8.158 8.158 0 0 0 3.338-3.8 4.708 4.708 0 0 0 1.161.363c2.242.368 5.551-.681 5.865-2.592s-2.491-3.957-4.734-4.325zM15.481 25.205l-2.995-1.655a6.876 6.876 0 0 0 1.691-2.85 52.26 52.26 0 0 0 4.773 1.994z"
  }));
}